import React from 'react';
import cx from 'classnames';
import Icon from '@components/@core/Icon';

const TaskHeader = ({ className, title }) => (
    <div className={cx('d-h-between', className)}>
        <span className="dsl-b22 bold">{title}</span>
        <Icon name="fas fa-chart-pie-alt" size={16} color="#c3c7cc" />
    </div>
);

export default TaskHeader;
